export default __webpack_public_path__ + "static/media/service03.4b40f97e.png";